import { Language } from './language';

export const Polish: Language = {
    loadingDescription: 'Ładowanie szablonów...',
    addToCart: 'DODAJ DO KOSZYKA',
    bodyColor: 'wybierz kolor korpusu',
    bedBodyColor: 'wybierz kolor oskrzyni',
    countertopColor: 'wybierz kolor blatu',
    frontColor: 'wybierz kolor drzwi',
    altFrontColor: 'wybierz kolor frontów',
    shelfColor: 'wybierz kolor półek',
    wallColor: 'wybierz kolor przegród',
    bedWallColor: 'wybierz kolor wezgłowia',
    handles: 'wybierz uchwyty',
    legs: 'wybierz nóżki',
    longLegs: 'wybierz nogi',
    frame: 'wybierz stelaż',
    undo: 'cofnij',
    redo: 'dalej',
    toggleFronts: 'ukryj/pokaż drzwi',
    removeElement: 'usuń',
    center: 'wyśrodkuj',
    changeHandlePosition: 'ustaw uchwyt',
    elements: 'skonfiguruj wnętrze lub wybierz gotowy układ',
    search: 'Wyszukaj...',
    width: 'szerokość',
    height: 'wysokość',
    depth: 'głębokość',
    currency: 'zł',
    colorAll: 'maluj wszystkie',
    colorSelected: 'maluj pojedynczo',
    saveProject: 'zapisz projekt',
    addToVoxBox: 'dodaj do VOXBOX',
    gotoTop: 'do góry',
    noSlotsAvailable: 'Wybrany element nie mieści się w obecnej konfiguracji mebla. Wybierz inny lub usuń przeszkadzające elementy.',
    projectSaved: 'Zapisano projekt',
    addedToVoxbox: 'Dodano do VOXBOX',
    addedToCart: 'Dodano do koszyka',
    addElements: 'dodawaj elementy wnętrza',
    chooseTemplate: 'wybierz gotową wersję mebla lub stwórz własny',
    addFronts: 'dodaj drzwi',
    saveProjectSplited_0: 'zapisz swój',
    saveProjectSplited_1: 'mebel',
    addToVoxBoxSplited_0: 'dodaj do',
    addToVoxBoxSplited_1: 'VOXBOX',
    addedWall: 'Aby zapewnić bezpieczną konstrukcję mebla dodaliśmy przegrodę',
    addedSupport: 'Aby zapewnić bezpieczną konstrukcję mebla dodaliśmy listwę wzmacniającą',
    hideFronts: 'Ukryliśmy drzwi, abyś mógł dodawać elementy wnętrza. Jeśli chcesz je ponownie zobaczyć, użyj przycisku UKRYJ/POKAŻ DRZWI',
    woodenElementsDisabled: 'Nie wszystkie zestawienia kolorystyczne drewnianych elementów dobrze ze sobą współgrają. Dla Twojej wygody zablokowaliśmy połączenia, które nie będą do siebie pasowały',
    noElements: 'W Twoim meblu nie ma ani jednego elementu takiego rodzaju',
    loadingScene: 'ładowanie sceny',
    resetColors: 'resetuj kolorystykę',
    resetModel: 'zacznij od nowa',
    resetModelSplitted_0: 'zacznij',
    resetModelSplitted_1: 'od nowa',
    loadingProductError: 'wystąpił problem podczas pobierania danych mebla',
    retry: 'spróbuj ponownie',
    unifyWoodColors: 'Kolor drewna, który chcesz wybrać nie pasuje do wcześniej użytych w Twoim meblu.\n\n\nWybranie tego koloru spowoduje zmianę wszystkich elementów drewnianych na ten kolor.\n\n\nJeśli chcesz tak zrobić, kliknij ponownie.',
    unifyWoodColorsSplitted_0: 'PORADA STYLISTY',
    unifyWoodColorsSplitted_1: 'Nie wszystkie kolory drewna ze sobą współgrają. Wybrany kolor nie pasuje do barw wcześniej użytych w Twoim meblu.',
    unifyWoodColorsSplitted_2: 'Ponowne kliknięcie spowoduje zmianę wszystkich drewnianych elementów na nowy odcień drewna.',
    noFronts: 'W Twoim meblu nie ma drzwi.',
    noElementsSelected: 'Nie wybrano żadnego elementu',
    toggleFrontsOpen: 'pokaż drzwi',
    toggleFrontsClose: 'ukryj drzwi',
    altToggleFrontsOpen: 'pokaż fronty',
    altToggleFrontsClose: 'ukryj fronty',
    shareProject_0: 'podziel się',
    shareProject_1: 'projektem',
    tooLongFrontForDrawer: 'Nie możesz dodać szuflady - nie pozwalają na to zbyt długie drzwi. Usuń drzwi i dodaj ich krótszy wariant.',
    hangersReserveSomeSpace: 'Drążek rezerwuje pod sobą trochę miejsca. Usuń drążek jeśli chcesz dodać pod nim szuflady',
    drawersDoNotHideBehindFronts: 'Szuflady nie pozwalają zamontować tych drzwi. Usuń je lub wybierz krótszy wariant.',
    doubleDoorsDoNotFitInFrontOfVerticalWalls: 'Pionowa przegroda uniemożliwia wstawienie podwójnych drzwi. Użyj pojedynczych drzwi lub usuń przegrodę i wstaw podwójne. Żeby usunąć przygodę usuń wszystkie przylegające do niej elementy np półki.',
    doubleDoorsDoNotFitTrySinglwDoors: 'Nie można dodać podwójnych drzwi. Spróbuj użyć ich pojedynczej wersji.',
    singleDoorsDoNotFitTryDoubleDoors: 'Nie można dodać pojedynczych drzwi. Spróbuj użyć ich podwójnej wersji.',
    doorBlockedByHorizontalWall: 'Usuń przegrodę lub wybierz mniejsze drzwi.',
    drawersDoNotFitBetweenShelf: 'Usuń półkę aby dodać szuflady.',
    tooltipDelete: 'Zaznacz element, który chcesz usunąć',
    tooltipSmallDrower_0: 'Szuflady dodajesz i zmieniasz parami.',
    tooltipSmallDrower_1: 'Ich wnętrza są zawsze białe.',
    productModalDescription: 'Tak prezentuje się Twój mebel Creative. Przed dodaniem do koszyka, upewnij się, że jest dokładnie taki, jaki sobie wymarzyłeś, ponieważ po złożeniu zamówienia nie będzie już możliwości jego modyfikacji.',
    yes: 'tak',
    no: 'nie',
    depthAbbreviation: 'g',
    widthAbbreviation: 's',
    heightAbbreviation: 'w',
    dimension: 'wymiary',
    summaryDrawers: 'szuflady',
    summaryHangers: 'drążek',
    summaryBodyColor: 'kolor korpusu',
    summaryShelfColor: 'kolor półek',
    summaryBarColor: 'kolor przegród',
    summaryBedHeadColor: 'kolor wezgłowia',
    summaryFrontsColor: 'kolor drzwi',
    summaryFrontsColor2: 'kolor frontów',
    summaryLegs: 'nóżki',
    summaryHandles: 'uchwyty',
    summaryFrame: 'stelaż',
    createYourOwn: 'stwórz własny',
    lack: 'brak',
    deliveryIn_0: 'Dostawa w',
    deliveryIn_1: 'dni roboczych',
    quantity: 'ilość',
    //colors
    white: 'biały',
    gray: 'szary',
    black: 'czarny',
    nude: 'nude',
    green: 'zielony',
    indigo: 'indygo',
    saffron: 'szafran',
    lightOak: 'dąb jasny',
    honneyOak: 'dąb miodowy',
    brownOak: 'dąb brązowy',
    darkOak: 'dąb ciemny',
    //elements
    shortShelf: 'półka krótka 42,5 cm',
    longShelf: 'półka długa 88 cm',
    shortHanger: 'drążek krótki 42,5 cm',
    longHanger: 'drążek długi 88 cm',
    shortDrawer: 'szuflady krótkie 42,5 cm',
    longDrawer: 'szuflady długie 88 cm',
    front1x1: '45x45',
    front1x2: '45x90',
    front1x3: '45x135',
    front1x4: '45x180',
    front2x1: 'podwójne 45x45',
    front2x2: 'podwójne 45x90',
    front2x3: 'podwójne 45x135',
    front2x4: 'podwójne 45x180',
    bedsideTableDrawer: 'szuflada 1x1',
    deskShortDrawer: 'szuflada 1x1',
    deskLongDrawer: 'szuflada 2x1',
    dressingShortDrawer: 'szuflada 1x1',
    dressingLongDrawer: 'szuflada 2x1',
    //handles
    push: 'push',
    oakTrapeze: 'trapez dębowy',
    metalCylinder: 'walec metalowy',
    metalTHandle: 'uchwyt T metalowy',
    leatherHandle: 'uchwyt skórzany',
    metalKnobLight: 'gałka metalowa',
    oakCylinder: 'walec dębowy',
    metalKnobDark: 'gałka metalowa',
    metalWireLight: 'drucik metalowy',
    oakStraightHandle: 'uchwyt prosty dębowy',
    metalWireDark: 'drucik metalowy',
    metalStraightHandle: 'uchwyt prosty metalowy',
    //legs
    supportLegs: 'podpora',
    oakStraightLegs: 'noga prosta dębowa',
    metalLegs: 'noga metalowa',
    metalSkid: 'płoza metalowa',
    sliderLegs: 'ślizgacz',
    woodenBrownObliqueFrameLegs: 'stelaż skośny drewniany',
    metalBentFrameLegs: 'stelaż gięty metalowy',
    metalStraightFrameLegs: 'stelaż prosty metalowy',
    metalObliqueFrameLegs: 'nogi skośne',
    oakObliqueFrameLegs: 'stelaż skośny dębowy',
    woodenBlackObliqueFrameLegs: 'stelaż skośny drewniany',
    woodenConeLegs: 'noga stożek drewniana',
    oakCylinderLegs: 'noga walec dębowa',
    //frames
    liftedFrame: 'podnoszony stelaż',
    floorFrame: 'podłoga na taśmie',
    floorWithFlexibleSlats: 'podłoga z listwami elastycznymi',
    productModalWarning: 'Uwaga!',
    productModalDescriptionWarning: 'Nie wybrałeś żadnego elementu wnętrza, aby konstrukcja mebla była prawidłowa dodaliśmy przegrodę. Tak prezentuje się teraz Twój mebel Creative.',
};
